<template>
 <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini">
        <div class="formItemBox">
          <el-form-item label="单号:" prop="formNo">
            <el-input placeholder="" v-model="searchFrom.formNo"></el-input>
          </el-form-item>
          <el-form-item label="审批状态 :" prop="status">
            <el-select v-model="searchFrom.status" placeholder="请选择">
              <el-option  label="全部" value="" ></el-option>
              <el-option  label="未审批" value="0" ></el-option>
              <el-option  label="审批通过" value="1" ></el-option>
              <el-option  label="审批驳回" value="2" ></el-option>
              <el-option  label="已审批" value="3" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型:" prop="formType">
            <el-select  v-model="searchFrom.formType" placeholder="请选择">
              <el-option v-for="val in ywlx" :label="val.name" :value="val.id" :key="val.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提交时间:" prop="createTime">
            <el-date-picker
              v-model="searchFrom.createTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="审批时间:" prop="checkTime">
            <el-date-picker
              v-model="searchFrom.checkTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-button type="primary" @click="getList">查询</el-button>
          <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
        </div>
      </el-form>
    </div>
   <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini"
        height="100%" style="width: 100%" center border class="tableComent">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="004P007B001"  v-if="btnFlg[0]&&scope.row.status==0"   @click="examineFn(scope.row.id,scope.row)">审批</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="formNo" width="200"  label="单号"></el-table-column>
         <el-table-column prop="outBillNo"  width="200"  :formatter="emptyFn" label="外部单号"></el-table-column>
         <el-table-column property="status" label="审批状态" >
          <template scope="scope">
            {{[ "未审批", "审批通过",'审批驳回','已审批'][scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column prop="auditUserName"  min-width="150"  label="实际审批人"></el-table-column>
        <el-table-column property="formType" min-width="100"  label="业务类型" >
          <template scope="scope">
            {{[ "实捆提货", "实捆转货",'发布货源','维修','虚捆提货','虚捆转货'][scope.row.formType-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="allWeight" min-width="100" label="重量（吨）"></el-table-column>
        <el-table-column prop="productNum" min-width="100" label="数量（件）"></el-table-column>
        <el-table-column prop="createUserName"  min-width="150" label="提交人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="提交时间"></el-table-column>
        <el-table-column prop="checkTime" width="170" :formatter="dateTimeFormat"  label="审批时间"></el-table-column>
      </el-table>
    </div>
      <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { FALList } from '@/api/soc-stock'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        status: '0'
      },
      total: 0,
      h: '',
      ywlx: [
        { name: '全部', id: '' },
        { name: '实捆提货', id: 1 },
        { name: '实捆转货', id: 2 },
        // { name: '发布货源', id: 3 }
        { name: '维修', id: 4 },
        { name: '虚捆提货', id: 5 },
        { name: '虚捆转货', id: 6 }
      ],
      btnFlg: [],
      btnIdArr: ['004P007B001']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/toDoTasks')
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.$set(this.searchFrom, 'organizationId', localStorage.getItem('createTenantCode'))
    }
    this.getList()
  },
  mounted () {
    this.$nextTick(() => {
      let h = this.$refs.searchBox.offsetHeight
      let pH = document.documentElement.clientHeight
      this.h = (pH - h - 165) + 'px'
    })
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      FALList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 审批
    examineFn (id, row) {
      this.$router.push({ name: 'DoExamine', query: { id: id, formType: row.formType, formId: row.formId } })
    },
    resetForm () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        status: '0'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}

</style>
